// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ModalWithIframe-index__modalWrapper--UGFt3","button":"ModalWithIframe-index__button--dp3sV","frame":"ModalWithIframe-index__frame--felnj"};